import React from 'react';

const PriorityDown: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="6"
      height="14"
      viewBox="0 0 6 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 13.5616L5.88675 8.56165L0.113249 8.56165L3 13.5616ZM3.5 9.06165L3.5 0.438355L2.5 0.438354L2.5 9.06165L3.5 9.06165Z"
        fill="#43AC8B"
      />
    </svg>
  );
};

export default PriorityDown;
